import { testsList } from "./index";
import { getWiremapImage } from "../../common/storage";

export const POST_RESULTS = "POST_RESULTS";

export const postResults = (jid, tid, pager) => ({
  type: POST_RESULTS,
  payload: {
    request: {
      url: `TestSummary/${jid}/${tid}`,
      method: "POST",
      data: pager
    }
  }
});

export const SUBTEST_RESULTS = "SUBTEST_RESULTS";
export const subtestResults = (jid, tid, type, device) => ({
  type: SUBTEST_RESULTS,
  payload: {
    request: {
      url: "subtestdetail",
      method: "POST",
      data: {
        request: {
          jobid: jid,
          testid: tid,
          subtesttypeid: type,
          handsettype: device
        }
      }
    }
  }
});

export const SUBTEST_RESULTS_RESET = "SUBTEST_RESULTS_RESET";
export const resetReducer = () => ({
  type: SUBTEST_RESULTS_RESET
});

export const SUBTEST_RESULTS_PREF_SET = "SUBTEST_RESULTS_PREF_SET";
export const setPreferences = preferences => ({
  type: SUBTEST_RESULTS_PREF_SET,
  data: preferences
});

export const HIDE_RESULTS = "HIDE_RESULTS";
export const hideResults = () => ({
  type: HIDE_RESULTS
});

export const HIDE_RESULT_HEADERS = "HIDE_RESULT_HEADERS";
export const hideResultHeader = () => ({
  type: HIDE_RESULT_HEADERS
});

export const CLEAR_RESULTS = "CLEAR_RESULTS";
export const clearResults = () => ({
  type: CLEAR_RESULTS
});

export const SIGNALTEK_POST_RESULTS = "SIGNALTEK_POST_RESULTS";

export const signaltekPostResults = (jid, tid, pager) => ({
  type: SIGNALTEK_POST_RESULTS,
  payload: {
    request: {
      url: `SignalTekTestSummary/${jid}/${tid}`,
      method: "POST",
      data: pager
    }
  }
});

export const SIGNALTEK_CLEAR_RESULTS = "SIGNALTEK_CLEAR_RESULTS";
export const signaltekClearResults = () => ({
  type: SIGNALTEK_CLEAR_RESULTS
});

export const SUBTEST_SIGNALTEK_RESULTS = "SUBTEST_SIGNALTEK_RESULTS";
export const getsubtestSignaltekResults = (jid, tid, type) => ({
  type: SUBTEST_SIGNALTEK_RESULTS,
  payload: {
    request: {
      url: "SignalTekSubTestDetail",
      method: "POST",
      data: {
        request: {
          jobid: jid,
          testid: tid,
          subtesttypeid: type
        }
      }
    }
  }
});

export const SUBTEST_WIREMAP_RESULTS = "SUBTEST_WIREMAP_RESULTS";
export const getsubtestWiremapResults = (jid, tid, type) => {
  //    type: SUBTEST_WIREMAP_RESULTS,
  //    payload: {
  //      request: {
  //        url: "WiremapSubTestDetail",
  //        method: "POST",
  //        data: {
  //          request: {
  //            jobid: jid,
  //            testid: tid,
  //            subtesttypeid: type
  //          }
  //        }
  //      }
  //    }
  //  });
  return (dispatch, getState) => {
    dispatch({
      type: SUBTEST_WIREMAP_RESULTS,
      payload: {
        request: {
          mode: "no-cors",
          url: `WiremapSubTestDetail`,
          method: "POST",
          data: {
            request: {
              jobid: jid,
              testid: tid,
              subtesttypeid: type
            }
          }
        }
      }
    }).then(response => {
      const subtestWiremapResults = response.payload.data;
      dispatch(wiremapLoaded(subtestWiremapResults));

      //fetch log only if the org has the logo set in the path
      // if (subtestWiremapResults.imagedata) {
      //   getWiremapImage(
      //     "771-siddhitest/signaltektests/190918/logo.png",
      //     subtestWiremapResults
      //   ).then(res => {
      //     subtestWiremapResults.wiremap = res.data;
      //     dispatch(wiremapLoaded(subtestWiremapResults));
      //   });
      // }
    });
  };
};

export const WIREMAP_RESULTS_LOADED = "WIREMAP_RESULTS_LOADED";
export const wiremapLoaded = subtestWiremapResults => ({
  type: WIREMAP_RESULTS_LOADED,
  data: {
    subtestWiremapResults
  }
});

export const SUBTEST_FIBER_LENGTH_LOSS_RESULTS = "SUBTEST_FIBER_LENGTH_LOSS_RESULTS";
export const getsubtestFiberLengthLossResults = (jid, tid, type) => ({
  type: SUBTEST_FIBER_LENGTH_LOSS_RESULTS,
  payload: {
    request: {
      url: "FiberLengthLossSubTestDetail",
      method: "POST",
      data: {
        request: {
          jobid: jid,
          testid: tid,
          subtesttypeid: type
        }
      }
    }
  }
});

export const SUBTEST_POE_RESULTS = "SUBTEST_POE_RESULTS";
export const getsubtestPoeResults = (jid, tid, type) => ({
  type: SUBTEST_POE_RESULTS,
  payload: {
    request: {
      url: "PoELoadSubTestDetail",
      method: "POST",
      data: {
        request: {
          jobid: jid,
          testid: tid,
          subtesttypeid: type
        }
      }
    }
  }
});

export const SUBTEST_MAXTHROUGHPUT_RESULTS = "SUBTEST_MAXTHROUGHPUT_RESULTS";
export const getsubtestMaxthroughputResults = (jid, tid, type) => ({
  type: SUBTEST_MAXTHROUGHPUT_RESULTS,
  payload: {
    request: {
      url: "MaxThroughputSubTestDetail",
      method: "POST",
      data: {
        request: {
          jobid: jid,
          testid: tid,
          subtesttypeid: type
        }
      }
    }
  }
});

export const SUBTEST_UPTIME_RESULTS = "SUBTEST_UPTIME_RESULTS";
export const getsubtestUptimeResults = (jid, tid, type) => ({
  type: SUBTEST_UPTIME_RESULTS,
  payload: {
    request: {
      url: "UptimeSummarySubTestDetail",
      method: "POST",
      data: {
        request: {
          jobid: jid,
          testid: tid,
          subtesttypeid: type
        }
      }
    }
  }
});

// export const SUBTEST_UPTIME_RESULTS_DETAILS = "SUBTEST_UPTIME_RESULTS_DETAILS";
// export const getsubtestUptimeResultsDetails = pager => ({
//   type: SUBTEST_UPTIME_RESULTS_DETAILS,
//   payload: {
//     request: {
//       url: `UptimeDetailSubTest/${pager.tid}`,
//       method: "POST",
//       data: pager
//     }
//   }
// });

export const SUBTEST_UPTIME_RESULTS_DETAILS = "SUBTEST_UPTIME_RESULTS_DETAILS";
export const getsubtestUptimeResultsDetails = pager => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SUBTEST_UPTIME_RESULTS_DETAILS,
        payload: {
          request: {
            url: `UptimeDetailSubTest/${pager.tid}`,
            method: "POST",
            data: pager
          }
        }
      })
        .then(response => {
          if (response.payload.data) {
            //dispatch(getsubtestUptimeResultsDetails(pager));
            resolve(response.payload.data);
          } else {
            reject(response.payload.data.errors);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  };
};

export const SUBTEST_UPTIME_RESULTS_BAR_CLICK =
  "SUBTEST_UPTIME_RESULTS_BAR_CLICK";
export const getsubtestUptimeResultsDetails_BarClick = item => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SUBTEST_UPTIME_RESULTS_BAR_CLICK,
        payload: {
          request: {
            url: "UptimeDetailPageNo",
            method: "POST",
            data: {
              testid: item.testid,
              index: item.index,
              pagesize: item.pagesize,
              sortfield: item.sortfield,
              desc: item.desc
            }
          }
        }
      })
        .then(response => {
          if (response.payload.data) {
            // const pageNumber = response.payload.data;
            // let pager = {
            //   global: false,
            //   jid: item.jid,
            //   manual: true,
            //   order: {},
            //   pageno: pageNumber,
            //   pagesize: 50,
            //   search: [],
            //   tid: item.testid
            // };
            // dispatch(getsubtestUptimeResultsDetails(pager));
            resolve(response.payload.data);
          } else {
            reject(response.payload.data.errors);
          }
        })
        .catch(err => {
          console.log(err);
        });

      // .then(response => {
      //   if (response.payload.data) {
      //     const pageNumber = response.payload.data;
      //     let pager = {
      //       global: false,
      //       jid: item.jid,
      //       manual: true,
      //       order: {},
      //       pageno: pageNumber,
      //       pagesize: 50,
      //       search: [],
      //       tid: item.testid
      //     };
      //     dispatch(getsubtestUptimeResultsDetails(pager));
      //   } else {
      //   }
      // });
    });
  };
};

export const GET_NETSCAN_RESULT = "GET_NETSCAN_RESULT";
export const getNetScanResult = pager => ({
  type: GET_NETSCAN_RESULT,
  payload: {
    request: {
      mode: "no-cors",
      url: `NetScanSubTestDetail/${pager.tid}`,
      method: "POST",
      data: pager
    }
  }
});

export const GET_STATS_RESULT = "GET_STATS_RESULT";
export const getStatsResult = (jid, tid, type) => ({
  type: GET_STATS_RESULT,
  payload: {
    request: {
      url: "StatsSubTestDetail",
      method: "POST",
      data: {
        request: {
          jobid: jid,
          testid: tid,
          subtesttypeid: type
        }
      }
    }
  }
});

export const SETSIGNALTEK = "SETSIGNALTEK";
export const setSignaltek = () => ({
  type: SETSIGNALTEK
});

export const CLEARSIGNALTEK = "CLEARSIGNALTEK";
export const clearSignaltek = () => ({
  type: CLEARSIGNALTEK
});

export const SUBTEST_SUBTESTSETTINGS_RESULTS =
  "SUBTEST_SUBTESTSETTINGS_RESULTS";
export const getsubtestSubTestsettingsResults = (jid, tid, type) => ({
  type: SUBTEST_SUBTESTSETTINGS_RESULTS,
  payload: {
    request: {
      url: "TransmissionSubTestDetail",
      method: "POST",
      data: {
        request: {
          jobid: jid,
          testid: tid,
          subtesttypeid: type
        }
      }
    }
  }
});

export const CLEAR_SUBTESTSETTINGS_RESULTS = "CLEAR_SUBTESTSETTINGS_RESULTS";
export const clearSubTestSettingsResult = () => ({
  type: CLEAR_SUBTESTSETTINGS_RESULTS
});
